// The TMS API speaks 12-hour times ("9:05 AM"); the wizard's form fields speak 24-hour ("09:05").

export const to12hr = (time24) => {
  if (!time24) { return null }
  const [ hours, minutes ] = time24.split(':').map(Number)
  // Without this an unparseable half renders as a plausible-looking "9:NaN AM".
  if (Number.isNaN(hours) || Number.isNaN(minutes)) { return null }
  const period = hours < 12 ? 'AM' : 'PM'
  return `${hours % 12 || 12}:${String(minutes).padStart(2, '0')} ${period}`
}

// For values that may already be 12-hour, or not a time at all: show what the API sent.
export const displayTime12 = (time) => {
  if (!time) { return null }
  if (/AM|PM/i.test(time)) { return time }
  return (/^\d{1,2}:\d{2}/).test(time) ? to12hr(time) : time
}

// The API speaks 12-hour ("1:30 PM"); a customer on 24-hour time needs it back.
export const displayTime = (time, hourFormat) => {
  const twelve = displayTime12(time)
  if (!twelve || hourFormat === 'am_pm') { return twelve }

  const parts = (/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i).exec(twelve)
  if (!parts) { return twelve }

  const [ , rawHours, minutes, period ] = parts
  const hours = (Number(rawHours) % 12) + (/PM/i.test(period) ? 12 : 0)
  return `${String(hours).padStart(2, '0')}:${minutes}`
}
